import React from "react";
import Table from "../Table";
import { Link } from "react-router-dom";
import moment from "moment";

// Report id : 101

const newReport_columns = [
  {
    name: "Application ID",
    selector: "applicationId",
    sortable: true,
    ignoreRowClick: true,
    keyField: "id",
    maxWidth: "25%"
  },

  {
    name: "Consumer GUID",
    selector: "guid",
    sortable: true,
    ignoreRowClick: true,
    keyField: "guid",
    cell: row => {
      return <span title={row.guid}>{row.guid}</span>;
    }
  },
  {
    name: "Status",
    selector: "status",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "14%"
  },
  {
    name: "Submitted On",
    selector: "submitted",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "15%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.submitted)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  },
  {
    name: "Completed On",
    selector: "completed",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "15%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.completed)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  }
];

// Report id : 102

const refresheport_columns = [
  {
    name: "Refresh application Id",
    selector: "applicationId",
    sortable: true,
    ignoreRowClick: true,
    keyField: "id",
    minWidth: "22%"
  },
  {
    name: "Original Application ID",
    selector: "originalApplicationId",
    sortable: true,
    ignoreRowClick: true,
    keyField: "id",
    minWidth: "22%"
  },

  {
    name: "GUID",
    selector: "guid",
    sortable: true,
    ignoreRowClick: true,
    keyField: "guid",
    cell: row => {
      return <span title={row.guid}>{row.guid}</span>;
    }
  },
  {
    name: "Status",
    selector: "status",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "10%"
  },
  {
    name: "Submitted On",
    selector: "submitted",
    sortable: false,
    ignoreRowClick: true,
    maxWidth: "13%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.submitted)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  },
  {
    name: "Completed On",
    selector: "completed",
    sortable: false,
    ignoreRowClick: true,
    maxWidth: "14%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.completed)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  }
];

// Report id : 103, 104
const reportSummary_columns_yca = [
  {
    name: "Total Application",
    selector: "count",
    sortable: true,
    ignoreRowClick: true
  },
  {
    name: "Completed",
    selector: "completed",
    sortable: false,
    ignoreRowClick: true
  },
  {
    name: "Error",
    selector: "errored",
    sortable: false,
    ignoreRowClick: true
  },
  {
    name: "In-Progress",
    sortable: false,
    ignoreRowClick: true,
    cell: row => {
      return <span>{row.inProgress + row.submitted}</span>;
    }
  }
];

const reportSummary_columns = [
  {
    name: "Snapshot Application Count",
    selector: "count",
    sortable: true,
    ignoreRowClick: true
  },
  {
    name: "Completed Snapshot Count",
    selector: "completed",
    sortable: false,
    ignoreRowClick: true
  },
  {
    name: "Error Snapshot Count",
    selector: "errored",
    sortable: false,
    ignoreRowClick: true
  },
  {
    name: "In-Progress Snapshot Count",
    sortable: false,
    ignoreRowClick: true,
    cell: row => {
      return <span>{row.inProgress + row.submitted}</span>;
    }
  }
];

function ReportsViewTable(props) {
  let columns = [],
    reportId = props.reportId,
    userType = JSON.parse(localStorage.getItem("userData")).userType;

  if (reportId == "101") {
    columns = newReport_columns;
  } else if (reportId == "102") {
    columns = refresheport_columns;
  } else if (reportId == "103" || reportId == "104") {
    if(userType && userType === "yca") {
      columns = reportSummary_columns_yca;
    } else {
      columns = reportSummary_columns;
    }
  }

  return (
    <Table
      columns={columns}
      data={props.reports}
      pagination={props.pagination}
      paginationPerPage={props.paginationPerPage}
      paginationRowsPerPageOptions={props.paginationRowsPerPageOptions}
    />
  );
}

export default ReportsViewTable;
